import * as React from "react";
const SvgFiRrCommentSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-1.536-1.536a5 5 0 0 0 .83-2.757v-5.69c0-3.433-1.502-6.648-4.12-8.822-2.508-2.085-5.677-2.894-8.919-2.293a10.9 10.9 0 0 0-4.99 2.362L1.706.293A.999.999 0 1 0 .293 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M10.33 3.163c2.648-.498 5.232.166 7.275 1.862C19.731 6.792 21 9.515 21 12.31V18c0 .451-.102.893-.293 1.293L6.393 4.978a8.86 8.86 0 0 1 3.936-1.816M17 22a1 1 0 0 1-1 1h-3.015c-3.78 0-7.234-1.509-9.474-4.14-2.037-2.392-2.876-5.464-2.362-8.645.125-.775.337-1.54.631-2.272a1.001 1.001 0 0 1 1.857.744 8.8 8.8 0 0 0-.513 1.847c-.419 2.595.26 5.092 1.91 7.031 1.86 2.184 4.757 3.436 7.951 3.436H16c.552 0 1 .446 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentSlash;
